/**
 * Note: View is always created, even if no codes exist
 * for now parent events passed to this (and other children)
 * */

var RaphaelView = require('raphaelItemView'),
    $ = require('jquery'),
    _ = require('underscore');

var instVars = {
    shape: null,
    selectedCodes: null,
    parent: null
};

module.exports = RaphaelView.extend({

    initialize: function(options) {

        _.extend( this, _.pick( options, instVars, 'shape', 'selectedCodes', 'parent') );

        this.listenTo( this.selectedCodes, 'add remove reset', this._printAndPosition );

        this.bindEntityEvents(this.parent, this.parentSubs);

    },

    parentSubs: {
        'shape.move shape.resizeRect shape.onAfterBaseScale shape.redaction.poly.resizeEnd': '_printAndPosition',
        'codeLetters.updateStyleAndPosition': 'setSVGAttributesAndLayeredPosition', // when called from toggleActive, could be incorporated into render now
        'redactionShape.layerCodesView': 'layer'
    },

    // mouse hover events: because now positioned atop parent shape when inactive,
    // forward mouseover, mouseout calls to the parent shape
    events: {
        'mouseover': 'onMouseover',
        'mouseout':  'onMouseout'
    },
    onMouseover: function(e) {
        this.parent.onEnterMouseHover.call( this.parent, e );
    },
    onMouseout: function(e) {
        this.parent.onExitMouseHover.call( this.parent, e );
    },

    render: function() {

        var rEl = this.shape.uiModel.raphaelEl(); // TODO: fn to get paper off shape ui model ...
        this.el = rEl.paper.text(0,0,'');

        this.setSVGAttributesAndLayeredPosition();

        // The canvas should now always be rendered in the DOM prior to printing any shapes,
        // so we don't need to worry about waiting for the canvas to load before printing the codes.
        (this.selectedCodes.length > 0) &&
            this._printAndPosition();

        // (necessary to wire events -- done in other views of this type)
        this.setElement( this.el );

        return this;

    },

    // DVBC-1393 - currently not most optimized or elegant positioning of the letters
    // but working in regards to keeping the letters in inside the rectangles.
    // This is intended to work with existing architecture (one Raphael text element) and
    // using method of splitting codes onto new lines if the shapes' height > than its width.
    // If this needs to be more elegant, do so when refactor with new drawing library.
    // Note: not intended to fit the codes in polygons; (we don't care about polygons);
    // This method is not as good for polygons as the old one
    // DVBC-1411 - change for to Courier to match CRE ... all calculation except the font-aspect ratio
    // are the same used for Arial which was more tested; appears to be working
    _printAndPosition: function() {

        var parentBox = this.shape.uiModel.getBBoxOfEl(),
            height = parentBox.height,
            width = parentBox.width,
            isWider = width > height,
            sCodes = this._getCodeTextToPrint(isWider);

        this.el.attr({
            'font-size': Math.floor( this._getFontSize( sCodes, height, width, isWider ) ),
            text: sCodes
        });

        this._position(parentBox);

    },

    // If the box is wider (than taller), put each code on a new line
    _getCodeTextToPrint: function( zoneIsWider ) {

        return this.selectedCodes.getCodesAsString( zoneIsWider ? ' ' : '\n' );

    },

    _getFontSize: function( sCodes, height, width, isWider ) {

        var COURIER_ASPECT_RATIO = 0.43, //(think of as units of height per column) -- MAYBE NOW DON'T NEED FOR MONOSPACE FONT
            PCT_H_PADDING = 0.35; // Conservative so letter fits inside; seems to work fine; will be taken as a percentage of the width (worked with .25)

        var aCodes = sCodes.split('\n'),
            nLines = aCodes.length;// if wider, will be one line; otherwise the number of codes

        // Determine a font size so that the longest line will fit inside the shape's width
        var maxLineLength = Math.max.apply( null, _.map( aCodes, function(c) {
                return c.length;
            })),
            desiredCharsPerLine = (width - (width * PCT_H_PADDING) ) / maxLineLength,
            fontSize = desiredCharsPerLine / COURIER_ASPECT_RATIO;

        // Now ensure text fits vertically after the above fit-width calculation

        if ( nLines === 1 ) {

            // Height adjustment: make sure the codes don't exceeds the height
            if (fontSize > height)
                fontSize = height - 1;

            // DVBC-1416: adjustment for text with underscore characters
            // these characters can go underneath the box
            // obviously not exact or most dynamic fix, but again, all this is quick fix to work in existing framework
            // problem only seems to occur with one line (so in here; see calcs below for when there are multiple lines)
            // and when the shape is wider (the lines aren't split)
            // must do after the height adjustment in case the height is larger than the font

            if ( sCodes.indexOf('_') > -1 && isWider )
                fontSize -= fontSize * 0.18;

        } else {

            // Vertically may not fit (esp. if there are many codes)
            // Also: Raphael's generated dy for tspans can be greater than the font size
            var RAPHAEL_LEADING = 1.2, // value in Raphael source (tuneText function) used in setting tspan's dy (font-size*this amount); unable to be monkey-patched
                V_BUFFER = 20; // Give some wiggle room in case

            if ( Math.floor( nLines * fontSize * RAPHAEL_LEADING ) + V_BUFFER > Math.ceil(height) ) {
                // Take the minimum to ensure we don't go over the width of the rectangle
                // Later 2 constants: some buffer just in case
                fontSize = Math.min( fontSize - 1 , (height / nLines / RAPHAEL_LEADING) - 2 );
            }
        }

        return fontSize;

    },

    /*  Center in parent el */
    _position: function(parentBox) { // could pass cached box

        var box = parentBox || this.shape.uiModel.getBBoxOfEl(),
            x = box.x + (box.width/2),
            y = box.y + (box.height/2);

        this.el.transform( 'T' + x + ',' + y  );

        return this.el;
    },


    setSVGAttributesAndLayeredPosition: function() {

        this.setSVGAttributes();
        this.layer();
    },

    setSVGAttributes: function() {
        this.el.attr( this.shape.getReasonCodeSvgAttrs( this.parent.getColorToApply() ) );
    },

    // When 'apply all redactions' is in effect, the redaction shape has no opacity.
    // So we need to move the letters in front of the shape for them to be visible.
    // But when the shape is active, we want the letters behind the shape ...
    // ( when active the shape has transparency and if the codes are in front, they will take over
    // the mouse cursor and events ).
    // Note: this is not attempting to solve the issue of which codes should appear above the other
    // (when they don't have opacity).
    layer: function() {

        this.shape.uiModel.get('isActive')
            ? this.el.insertBefore( this.shape.uiModel.raphaelEl() )
            : this.el.insertAfter( this.shape.uiModel.raphaelEl() );

    },

    // DVBC-1762: don't destroy the selected codes.  For now, at least for full page
    // redactions, we need to persist them on activeNote change (on the note model); and we may later
    // want to start parsing shape models on parse of other note models as well.
    onBeforeDestroy: function() {

        this.undelegateEvents(); //(uses custom unbind all for Raphael view -- undelegate the events on here )
        this.unbindEntityEvents(this, this.parentSubs);

        this.stopListening();
        this.off();
        this.el.remove(); //memory leak somewhere ...
    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/views/shape/redaction/codeLetters.js
 ** module id = 234
 ** module chunks = 0
 **/